/* eslint-disable react/no-multi-comp, react/prop-types */

import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';

import SVG from 'components/widgets/icons/svg';
import { RoundLoader } from 'components/widgets/state-indicators/loader';
import ActionCompleteIndicator from 'components/widgets/state-indicators/complete-indicator';
import Tooltip from 'components/widgets/overlays/tooltip';


// Components
export function SubmitButton(props) {
  return <Button defaultClasses="submit-button" type="submit" {...props} />;
}

SubmitButton.defaultProps = {
  content: 'Save'
};

export function ApplyButton(props) {
  return <Button defaultClasses="add-button" type="submit" content="Apply" {...props} />;
}

export function PrimaryButton(props) {
  return <Button defaultClasses="btn-success" {...props} />;
}

export function SecondaryButton(props) {
  return <Button defaultClasses="btn-secondary" {...props} />;
}

export function NegativeButton(props) {
  return <Button defaultClasses="btn-danger" {...props} />;
}

export function WarningButton(props) {
  return <Button defaultClasses="btn-warning" {...props} />;
}

export function DeemphasizedButton(props) {
  return <Button defaultClasses="btn-default deemphasized-button" {...props} />;
}

export function DeemphasizedNegativeButton(props) {
  return <Button defaultClasses="btn-default deemphasized-negative-button" {...props} />;
}

export function CancelButton(props) {
  return <Button defaultClasses="btn-default" {...props} />;
}

export function LinkButton(props) {
  return <Button defaultClasses="link-button" {...props} />;
}


// SVG Buttons
export function RemoveButton(props) {
  return <SVGButton defaultClasses="remove-button" title="Remove" src="svg/close.svg" {...props} />;
}

export function CloseButton(props) {
  return <SVGButton defaultClasses="remove-button" title="Close" src="svg/close.svg" {...props} />;
}

export function AddButton(props) {
  return <SVGButton defaultClasses="add-button" title="Add" src="svg/add.svg" {...props} />;
}

export function EditButton(props) {
  return <SVGButton defaultClasses="edit-button edit-link" title="Edit" src="svg/edit.svg" {...props} />;
}

export function RestoreButton(props) {
  return <SVGButton defaultClasses="restore-button" title="Restore" src="svg/refresh.svg" {...props} />;
}

export function DeleteButton(props) {
  return <SVGButton defaultClasses="delete-button archive" title="Delete" src="svg/delete.svg" {...props} />;
}

export function SVGButton(props) {
  return (
    <Button
      defaultClasses={classNames(props.defaultClasses, props.classNames, props.className, 'svg-only-button')}
      tabIndex="-1"
      content={props.showLoading ? null : <SVG src={props.src} />}
      {..._.omit(props, ['defaultClasses'])}
    />
  );
}


// Base buttons
export class Button extends React.Component {
  constructor() {
    super();
    this.state = { showComplete: false };
  }

  componentWillReceiveProps(nextProps) {
    // If the button was showing the loading indicator and is now not, and has permission
    // from its parent component to show the complete indicator, show the complete indicator
    if (!nextProps.showLoading && this.props.showLoading && nextProps.showComplete) {
      this.setState({ showComplete: true });
    }
  }

  render() {
    const {
      className,
      defaultClasses,
      type,
      content,
      children,
      showLoading,
      disabled,
      onClick,
      loaderColor,
      title,
      placement,
      ...props } = this.props;

    const button = (
      <button
        {..._.omit(props, 'showComplete')}
        type={type || 'button'}
        // If the button is disabled, don't actually disable it (as this prevents bootstrap tooltips
        // from showing), but give it a disabled class and prevent it from performing its action
        // when it's clicked
        className={classNames('button', className, defaultClasses, { disabled: disabled || showLoading })}
        onClick={(disabled || showLoading) ? _.noop : onClick}
      >
        { showLoading &&
          <RoundLoader color={loaderColor} />
        }
        { this.state.showComplete && !showLoading &&
          <ActionCompleteIndicator />
        }
        {content || children}
      </button>
    );

    if (!title) return button;

    return (
      <Tooltip title={title} placement={placement}>{button}</Tooltip>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/widgets/buttons/buttons.js